const mobileRouter = [
  //移动端 页面 周报
  {
    path: '/wap/particulars/:json',
    name: 'wapParticulars',
    component: () =>
      import(/*webpackChunkName:"common" */ '@/views/wap/particulars.vue'),
    meta: {
      title: '周报',
    },
  },
  //移动端 页面 月报
  {
    path: '/wap/month-magazine/:json',
    // path: '/wap/month-magazine/:company_id/:target_account_id/:year/:month',
    name: 'monthMagazine',
    component: () =>
      import(/*webpackChunkName:"common" */ '@/views/wap/MonthMagazine.vue'),
    meta: {
      title: '月报',
    },
  },
  //移动端 老数据查看H5 company_code role_number client_name type 1拜访 2活动 3行程备案
  {
    path: '/wap/old-data-list/:company_code/:role_number/:client_name/:type',
    name: 'wapOldDataList',
    component: () =>
      import(
        /*webpackChunkName:"wapOldDataList" */
        '@/views/wap/oldDataH5/list.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 老数据查看H5 详情
  {
    path: '/wap/old-data-details/:company_code/:company_id/:account_id/:account_role_id/:typeId/:type',
    name: 'wapOldDataDetails',
    component: () =>
      import(
        /*webpackChunkName:"wapOldDataDetails" */
        '@/views/wap/oldDataH5/Details.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 老数据查看H5 拜访对象详情
  {
    path: '/wap/visit-object-details/:json',
    name: 'wapVisitObjectDetails',
    component: () =>
      import(
        /*webpackChunkName:"wapVisitObjectDetails" */
        '@/views/wap/oldDataH5/VisitObjectDetails.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 老数据查看H5 查看地图
  {
    path: '/wap/records-map/:json',
    name: 'wapRecordsMap',
    component: () =>
      import(
        /*webpackChunkName:"wapMap" */
        '@/views/wap/oldDataH5/recordsMap.vue'
      ),
    meta: {
      title: '',
    },
  },
  //点击导出表格链接，跳转到地图
  {
    path: '/wap/signin-map/:type/:id/:json',
    name: 'wapSigninMap',
    component: () =>
      import(
        /*webpackChunkName:"wapMap" */
        '@/views/wap/oldDataH5/SigninMap.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 九新考核分数
  {
    path: '/wap/jiuxin-assess-score/:quarter_id/:company_id/:from/:month/:quarter',
    name: 'wapJiuxinAssessScore',
    component: () =>
      import(
        /*webpackChunkName:"wapJiuxinAssessScore" */
        '@/views/wap/jiuxin/JiuxinAssessScore.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 九新分数排行
  {
    path: '/wap/jiuxin-score-ranking/:quarter_id/:company_id/:is_admin',
    name: 'wapJiuxinScoreRanking',
    component: () =>
      import(
        /*webpackChunkName:"wapJiuxinScoreRanking" */
        '@/views/wap/jiuxin/JiuxinScoreRanking.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 九新分数排行 自营考核榜
  {
    path: '/wap/jiuxin-score-ranking/:quarter_id/:company_id/:is_admin/:selfSupport',
    name: 'wapJiuxinScoreRankingSelfSupport',
    component: () =>
      import(
        /*webpackChunkName:"wapJiuxinScoreRanking" */
        '@/views/wap/jiuxin/JiuxinScoreRanking.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 九新考核分数 排行
  {
    path: '/wap/jiuxin-assess-score2/:quarter_id/:company_id/:from/:dashboard_type/:json',
    name: 'wapJiuxinAssessScore2',
    component: () =>
      import(
        /*webpackChunkName:"wapJiuxinAssessScore" */
        '@/views/wap/jiuxin/JiuxinAssessScore.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 问卷填写
  {
    path: '/wap/questionnaire-fill/:account_id/:company_id/:quarter_id/:activity_id/:crm_template_id/:type/:department_id',
    name: 'wapQuestionnaireFill',
    component: () =>
      import(
        /*webpackChunkName:"wapQuestionnaireFill" */
        '@/views/wap/questionnaire/QuestionnaireFill.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 查看文章资料
  {
    path: '/wap/article/:study_material_id/:company_id/:account_id/:quarter_id/:department_id/:study_cycle_id',
    name: 'wapArticle',
    component: () =>
      import(
        /*webpackChunkName:"wapArticle" */
        '@/views/wap/article/Detail.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 学习平台考核内容
  {
    path: '/wap/study/examination/:study_cycle_id/:company_id/:account_id/:quarter_id/:department_id',
    name: 'wapStudyExamination',
    component: () =>
      import(
        /*webpackChunkName:"wapStudyExamination" */
        '@/views/wap/study/examination.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 学习平台考核详情
  {
    path: '/wap/study/examination-details/:study_participant_id/:company_id',
    name: 'wapStudyExaminationDetails',
    component: () =>
      import(
        /*webpackChunkName:"wapStudyExaminationDetails" */
        '@/views/wap/study/examinationDetails.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端  商务订单二维码
  {
    path: '/wap/businessOrder/qr-code/:qr_data',
    name: 'wapBusinessOrderqrCode',
    component: () =>
      import(
        /*webpackChunkName:"wapBusinessOrderqrCode" */
        '@/views/wap/businessOrder/qrCode.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端  商务订单验证信息
  {
    path: '/wap/businessOrder/verify-info/:account_id/:company_id/:department_id/:is_admin/:quarter_id',
    name: 'wapBusinessOrderVerifyInfo',
    component: () =>
      import(
        /*webpackChunkName:"wapBusinessOrderVerifyInfo" */
        '@/views/wap/businessOrder/verifyInfo.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端  创建商务订单
  {
    path: '/wap/businessOrder/create-business-order/:realname/:title/:client_id/:account_id/:company_id/:department_id/:is_admin/:quarter_id',
    name: 'wapBusinessOrderCreateBusinessOrder',
    component: () =>
      import(
        /*webpackChunkName:"wapBusinessOrderCreateBusinessOrder" */
        '@/views/wap/businessOrder/createBusinessOrder.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端  创建商务订单选择采购产品
  {
    path: '/wap/businessOrder/select-procurement-products/:realname/:title/:client_id/:account_id/:company_id/:department_id/:is_admin/:quarter_id',
    name: 'wapBusinessOrderSelectProcurementProducts',
    component: () =>
      import(
        /*webpackChunkName:"wapBusinessOrderSelectProcurementProducts" */
        '@/views/wap/businessOrder/selectProcurementProducts.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端  创建商务订单添加产品
  {
    path: '/wap/businessOrder/add-products/:index/:realname/:title/:client_id/:account_id/:company_id/:department_id/:is_admin/:quarter_id',
    name: 'wapBusinessOrderAddProducts',
    component: () =>
      import(
        /*webpackChunkName:"wapBusinessOrderAddProducts" */
        '@/views/wap/businessOrder/addProducts.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端  创建商务订单添加产品---选择产品
  {
    path: '/wap/businessOrder/add-products-select/:index/:realname/:title/:client_id/:account_id/:company_id/:department_id/:is_admin/:quarter_id',
    name: 'wapBusinessOrderAddProductsSelect',
    component: () =>
      import(
        /*webpackChunkName:"wapBusinessOrderAddProductsSelect" */
        '@/views/wap/businessOrder/addProductsSelect.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端  创建商务订单选择收货地址
  {
    path: '/wap/businessOrder/select-address/:realname/:title/:client_id/:account_id/:company_id/:department_id/:is_admin/:quarter_id',
    name: 'wapBusinessOrderSelectAddress',
    component: () =>
      import(
        /*webpackChunkName:"wapBusinessOrderSelectAddress" */
        '@/views/wap/businessOrder/selectAddress.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端  创建商务订单添加地址
  {
    path: '/wap/businessOrder/add-address/:index/:realname/:title/:client_id/:account_id/:company_id/:department_id/:is_admin/:quarter_id',
    name: 'wapBusinessOrderAddAddress',
    component: () =>
      import(
        /*webpackChunkName:"wapBusinessOrderAddAddress" */
        '@/views/wap/businessOrder/addAddress.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端  创建商务订单成功
  {
    path: '/wap/businessOrder/create-success',
    name: 'wapBusinessOrderCreateSuccess',
    component: () =>
      import(
        /*webpackChunkName:"wapBusinessOrderCreateSuccess" */
        '@/views/wap/businessOrder/createSuccess.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 通知公告详情
  {
    path: '/wap/notice/detail/:crm_notice_id/:company_id/:account_id/:quarter_id',
    name: 'wapNoticeDetail',
    component: () =>
      import(
        /*webpackChunkName:"wapNoticeDetail" */
        '@/views/wap/notice/Detail'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 勤奋榜 积分说明
  {
    path: '/wap/score/introduce',
    name: 'wapScoreIntroduce',
    component: () =>
      import(/*webpackChunkName:"wapScore" */ '@/views/wap/score/Introduce'),
    meta: {
      title: '积分说明',
    },
  },
  //移动端 流向查询
  {
    path: '/wap/flowDirectionQuery/:company_id/:quarter_id/:is_admin/:month_date/:goods_id',
    name: 'wapFlowDirectionQuery',
    component: () => import('@/views/wap/flowDirectionQuery'),
    meta: {
      title: '流向查询',
    },
  },
  //移动端 问卷填写(预览用)
  {
    path: '/wap/questionnaire-fillTwo/:account_id/:company_id/:quarter_id/:activity_id/:crm_template_id/:type/:department_id/:is_disabled',
    name: 'wapQuestionnaireFillTwo',
    component: () =>
      import(
        /*webpackChunkName:"wapQuestionnaireFill" */
        '@/views/wap/questionnaire/QuestionnaireFill.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 行业数据分析覆盖率
  {
    path: '/wap/industryAnalysis/coverageRate/:company_id/:quarter_id/:province_id/:cls/:province_name/:goods_id/:tab',
    name: 'wapIndustryAnaltsisCoverageRate',
    component: () =>
      import(
        /*webpackChunkName:"wapIndustryAnaltsisCoverageRate" */
        '@/views/wap/industryAnalysis/coverageRate.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 商业流向查看
  {
    path:
      // '/wap/businessFlow/look',
      '/wap/businessFlow/look',

    name: 'wapBusinessFlowLook',
    component: () =>
      import(
        /*webpackChunkName:"wapBusinessFlowLook" */
        '@/views/wap/businessFlow/look.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 照片识别
  {
    path: '/wap/photo-array/take-photo',
    name: 'wappPhotoArrayTakePhoto',
    component: () =>
      import(
        /*webpackChunkName:"wappPhotoArrayTakePhoto" */
        '@/views/wap/photoArray/takePhoto.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 照片确认
  {
    path: '/wap/photo-array/confirm-photo',
    name: 'wappPhotoArrayConfirmPhoto',
    component: () =>
      import(
        /*webpackChunkName:"wappPhotoArrayConfirmPhoto" */
        '@/views/wap/photoArray/confirmPhoto.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 照片识别结果
  {
    path: '/wap/photo-array/identify-result',
    name: 'wappPhotoArrayIdentifyResult',
    component: () =>
      import(
        /*webpackChunkName:"wappPhotoArrayIdentifyResult" */
        '@/views/wap/photoArray/identifyResult.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 照片识别结果列表
  {
    path: '/wap/photo-array/photo-list',
    name: 'wappPhotoArrayPhotoList',
    component: () =>
      import(
        /*webpackChunkName:"wappPhotoArrayPhotoList" */
        '@/views/wap/photoArray/photoList.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 照片识别结果详情
  {
    path: '/wap/photo-array/photo-detail',
    name: 'wappPhotoArrayPhotoDetail',
    component: () =>
      import(
        /*webpackChunkName:"wappPhotoArrayPhotoDetail" */
        '@/views/wap/photoArray/photoDetail.vue'
      ),
    meta: {
      title: '',
    },
  },
  //移动端 admin预警内容推送
  {
    path: '/wap/content-push/index/:push_id',
    name: 'wappContentPush',
    component: () => import('@/views/wap/contentPush/index.vue'),
    meta: {
      title: '',
    },
  },
  //移动端 帮助说明
  {
    path: '/wap/help/:type',
    name: 'wapHelp',
    component: () => import('@/views/wap/help/index.vue'),
    meta: {
      title: '',
    },
  },
]

export default mobileRouter
